import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import {
  Grid,
  Button
} from '@mui/material';
import {
  fields,
  validationUtil,
  authService
} from 'modules';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';


const __formSchema = yup.object({
  currentPassword: validationUtil.passwordSchema.required('Current Password is required'),
  newPassword: validationUtil.confirmPasswordSchema('confirmNewPassword').required('Confirm New Password is required'),
  confirmNewPassword: validationUtil.confirmPasswordSchema('newPassword').required('New Password is required')
}).required();

type IFormData = yup.InferType<typeof __formSchema>;

const ControlledTextField = fields.genTextFieldControllerComponent<IFormData>();



export const EditAccountSection: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const form = useForm<IFormData>({
    resolver: yupResolver(__formSchema),
    shouldFocusError: true
  });



  async function processSubmit(formData: IFormData) {
    try {
      setLoading(true);
      await authService.updatePassword(formData.currentPassword, formData.newPassword);
      form.reset();
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  }



  return (
    <form onSubmit={form.handleSubmit(processSubmit)}>
      <Grid container spacing={5}>
        <Grid
          container item
          spacing={5}>
          <Grid item xs>
            <ControlledTextField
              type="password"
              formControl={form.control}
              fieldKey="currentPassword"
              label="Current Password" />
          </Grid>

          <Grid item xs>
            <ControlledTextField
              type="password"
              formControl={form.control}
              fieldKey="newPassword"
              label="New Password" />
          </Grid>

          <Grid item xs>
            <ControlledTextField
              type="password"
              formControl={form.control}
              fieldKey="confirmNewPassword"
              label="Confirm New Password" />
          </Grid>
        </Grid>

        <Grid item xs>
          <Button
            type="submit"
            variant="contained"
            size="medium"
            disabled={loading}>
            Update Password
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
